"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconFullscreen = function IconFullscreen(_ref) {
  var className = _ref.className,
      color = _ref.color;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "50",
    height: "50",
    viewBox: "0 0 50 50",
    fill: "none",
    className: className
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 15H32V11H42V21H38V15Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 35L18 35L18 39L8 39L8 29L12 29L12 35Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 35L38 29L42 29L42 39L32 39L32 35L38 35Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 15L12 21L8 21L8 11L18 11L18 15L12 15Z",
    fill: color
  }));
};

IconFullscreen.defaultProps = {
  color: 'black'
};
IconFullscreen.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconFullscreen;
exports.default = _default;